<template>
    <div class="meeting-container">
        <div class="overlay" v-if="isOnPriva">
            <div>
                 <p>
                工作人员正在对参会人进行一对一视频私聊
                </p>
                <br>
                <p>
                    会议暂停，请您稍后
                </p>
                <br>
                <p>{{ptivateMytime}}</p>
            </div>
        </div>
        <div :class="[{insideopen: insideshow},'meeting-main']">
            <div class="meeting-header clearfix">
                <div class="meeting-class-title">
                    <div class="meeting-videocontral">
                        <div :class="[{on:isaudioopen},'audioswitch item']" @click="closeAudioMedtiator(userID,0)">{{isaudioopen ? '关闭语音' : '开启语音'}}</div>
                        <div :class="[{on:isvideoopen},'videoswitch item']" @click="closeVideoMedtiator(userID,0)">{{isvideoopen ? '关闭视频' : '开启视频'}}</div>
                        <!-- <div class="item" @click="sendRoom">get room</div> -->
                        <div class="center">
                            <!-- <div :class="[{on:isRaiseHand},'handswitch item']" @click="raiseHand" v-if="!isaudioopen && audioStatus === false">举手</div> -->
                            <div v-if="showPrivateChat" :class="[{on:isMediatorMessage},'chatswitch item']" @click="openMediatorChat">文字私聊</div>
                        </div>
                    </div>
                    <div class="meetingexit"><div class="quit" @click="goHomeRouter"><i class="ico_quit"></i>离开视频</div></div>
                </div>
            </div>
            <div class="meeting-area-main">
                <div class="curmemberinfo">
                    <span class="memberinfo">
                        <div v-if="mainView.streamId === undefined">{{mainView.name}}</div>
                        <div v-else>{{mainView.role == 'MEDIATOR'?mainView.rolename:(mainView.rolename+'：'+mainView.name)}}</div>
                        <i class="audio" v-if="!Boolean(requestingPushers[mainView.id] && requestingPushers[mainView.id].audio)"></i>
                        <i class="hand" v-if="handMap[mainView.id]"></i>
                    </span>
                    <i class="timing">{{mytime}}</i>
                    <el-dropdown class="more" v-if="(mainView.id==userID) || selectedMainViewId">
                        <span class="el-dropdown-link">
                            <i class="more-icon"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="mainView.id==userID"><div @click="closeAudioMedtiator(mainView.id,0)">{{isaudioopen ? '关闭语音' : '开启语音'}}</div></el-dropdown-item>
                            <el-dropdown-item v-if="mainView.id==userID"><div @click="closeVideoMedtiator(mainView.id,0)">{{isvideoopen ? '关闭视频' : '开启视频'}}</div></el-dropdown-item>
                            <el-dropdown-item v-if="selectedMainViewId"><div @click="partyCancelMainScreen(mainView.id)">取消主视频</div></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-show="(onlineStatus[mainView.id]=='ONLINE')&&Boolean(requestingPushers[mainView.id])&&!Boolean(requestingPushers[mainView.id] && requestingPushers[mainView.id].video)" class="exitroom">{{mainView.role == 'MEDIATOR'?mainView.rolename:mainView.name}} 关闭了视频</div>
                <div v-show="onlineStatus[mainView.id]=='OFFLINE'" class="exitroom">{{mainView.role == 'MEDIATOR'?mainView.rolename:mainView.name}} 离开了视频会议</div>
                <div v-if="!Boolean(onlineStatus[mainView.id])" class="exitroom">等待进入视频会议</div>
                <video id="localVideo" class="mainvideo" autoplay playinline></video>
            </div>
            <div class="member-list-container">
                <div class="right_scroll" @click="memberListScroll(false)"></div>
                <div ref="meetingMemberList" class="meeting-member-list-inner">
                    <ul class="meeting-scroll" v-bind:style="'width:'+members.length*250+'px'">
                        <template v-for="(item, index) in members">
                            <li class="meeting-member-box" :key="index" v-if="(item.id != mainView.id) && item.id">
                                <div class="meeting-member-body">
                                    <div class="meeting-member-body-info">
                                        <div>
                                            <!-- <i v-if="item.id==userID" :class="[{on:isaudioopen},'icon_useraudio']"></i> -->
                                            <i :class="[{on:Boolean(requestingPushers[item.id] && requestingPushers[item.id].audio)},'icon_useraudio']"></i>
                                            <!-- <i v-if="item.id==userID" :class="[{on:isvideoopen},'icon_uservideo']"></i> -->
                                            <el-dropdown class="more">
                                                <span class="el-dropdown-link">
                                                    <i class="more-icon"></i>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item v-if="item.id==userID"><div @click="closeAudioMedtiator(item.id,0)">{{isaudioopen ? '关闭语音' : '开启语音'}}</div></el-dropdown-item>
                                                    <el-dropdown-item v-if="item.id==userID"><div @click="closeVideoMedtiator(item.id,0)">{{isvideoopen ? '关闭视频' : '开启视频'}}</div></el-dropdown-item>
                                                    <el-dropdown-item><div @click="setMainScreen(item.id, true)">设为主视频</div></el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                            <el-button v-if="item.id==userID" @click="closeAudioMedtiator(item.id,0)" class="video-btn" size="mini">
                                                {{Boolean(requestingPushers[item.id] && requestingPushers[item.id].audio) ? '关闭语音' : '开启语音'}}
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                <!-- 互动人员图片 start -->
                                <div class="meeting-member-img" :id="'video_'+(item.id)">
                                    <div v-if="pusherVideosDisplay[item.id]" class="exitroom">{{item.name}} {{item.id!=privateUserId?'断开了视频连接':'正在私聊中'}}</div>
                                    <div v-if="!Boolean(requestingPushers[item.id] && requestingPushers[item.id].video)&&!Boolean(pusherVideosDisplay[item.id])" class="exitroom">{{item.name}} 视频被关闭</div>
                                    <video :id="'v_'+(item.id)" style=" margin-left: -50px; width:330px; height:190px;" autoplay playsinline></video>
                                </div>
                                <!-- 互动人员图片 end -->
                                <!-- 互动信息   要 start -->
                                <div class="meeting-member-foot">
                                    <span v-if="item.streamId === undefined" class="meeting-member-name">{{item.name}}</span>
                                    <span v-else class="meeting-member-name">{{item.role == 'MEDIATOR'?item.rolename:(item.rolename+':'+item.name)}}</span>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="left_scroll" @click="memberListScroll(true)"></div>
            </div>
        </div>
        <div :class="[{insideopen: insideshow}, 'meeting-inside']">
            <div class="inside_button">
                <div v-if="!insideshow" class="inside_menu ico_btn_a" @click="openinside('first')">沟通记录</div>
                <!-- <div v-if="!insideshow" class="inside_menu ico_btn_b" @click="openinside('second')">会议材料</div> -->
                <div v-if="!insideshow" class="inside_menu ico_btn_c" @click="openinside('third')">工作区</div>
                <div v-if="insideshow" class="inside_menu_close" @click="openinside('first')">收起</div>
            </div>
            <inside v-show="insideshow" ref="inside" v-model="comdata" :wselement="ws" :meetingId="meetingId" :singleCaseId="singleCaseId" @comcallback="changStatushNotice" @sourceMessage="setSource"></inside>
        </div>
        <privatechat ref="privatechat" v-model = "comdata" :wselement="ws" :socketStatus="socketStatus" :members="member_list" @comcallback="changStatushMessage" @sourceMessage="setSource"></privatechat>
        <bobao ref="Dialogbobao" :Bobaovideo1="Bobaovideo1" :Bobaovideo2="Bobaovideo2" :ws="ws" :comdata="comdata"></bobao>
    </div>
</template>
<script>
import axios from 'axios'
import inside from '../components/inside.vue'
import privatechat from '../components/privatechat.vue'
import bobao from '../components/bobao'
import {setStore,getStore,removeStore} from '@/utils/utils.js'
import {getMediationInfo} from '@/api/meeting'
import meetingMixins from '../assets/js/meetingMixins.js'
export default {
    mixins: [meetingMixins],
    components: {
        'inside':inside,
        'privatechat':privatechat,
        'bobao': bobao
    },
    data(){
        return {
            // ptivateMytime:''
            singleCaseId:0,
            meetingId:0,
            // 是否展示私聊
            showPrivateChat: false
        }
    },
    mounted(){
        // this.time_funs(true)
    },
    created() {
        let query = this.$route.query, self = this, userCommon, userMediator,userInfo;
        userCommon = JSON.parse(getStore('loginInfouser'))
        userMediator = JSON.parse(getStore('loginInfo'))
        userInfo = userCommon?userCommon.userInfo:userMediator?userMediator.userInfo:{}
        this.singleCaseId = this.$route.query.caseid
        this.meetingId = this.$route.query.meetingid
        if(!query.token && !getStore('flk')){
            self.$alert('<h4 class="title_normal">温馨提示</h4><div>用户未登录</div>', '温馨提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                confirmButtonClass: 'meeting_button_primary_small',
                customClass: 'alert_quit'
            }).then(() => {
                document.location.href= '/login'
            });
            return;
        }else{
            self.userID = query.memberId || userInfo.userId
            self.canDraw = true;
            self.selfName = query.memberName || userInfo.userName
            self.iswatcher = false
            self.ismediator = false
            self.istemporary = false
            self.ispusher = false
            self.invite = self.$route.query.invite
            self.roomID = self.$route.query.roomid
            self.caseID = self.$route.query.caseid
            self.meetingID = self.$route.query.meetingid
            self.comdata = {
                'caseID': self.$route.query.caseid,
                'roomID': self.$route.query.roomid,
                'meetingID': self.$route.query.meetingid,
                'userID': self.userID,
                'selfName': self.selfName,
                'iswatcher': false,
                'ispusher': false, //区分有无画面（有画面观摩人，无画面观摩人）
                'istemporary': false,
                'invite': self.$route.query.invite,
                'mediatorself': false,
                'roleType': null
            }
            self.userToken = self.$route.query.token || getStore('flk');
        }

        self.webRtcInit()

        console.log('member mainView', self.mainView)
    },
    methods:{
        // time_funs(status) { // 计时
        //     let sec = 0,
        //         self = this;
        //     if (status) {
        //         let interval = self.intervalRest = setInterval(function() {
        //             sec++;
        //             let date = new Date(0, 0)
        //             date.setSeconds(sec);
        //             let h = date.getHours(),
        //                 m = date.getMinutes(),
        //                 s = date.getSeconds();
        //                 console.log( self.ptivateMytime)
        //             self.ptivateMytime = (h >= 10 ? h : "0" + h) + ":" + (m >= 10 ? m : "0" + m) + ":" + (s >= 10 ? s : "0" + s);
        //         }, 1000);
        //     } else {
        //         console.log("clear")
        //         clearInterval(self.intervalRest);
        //     }
        // },
        videoChat(){
            this.$router.push({
                path:'/meetingChat',
                query:{
                    userId:this.userID,
                    meetingid:this.$route.query.meetingid,
                    caseid:this.$route.query.caseid
                }
            })
        }
    },
}
</script>
<style lang="scss">
    @import '../assets/css/meetingCss.scss';
    .overlay{
        width: 100%;
        height: 100%;
        top:0px;left:0px;
        z-index:1001;
        background-color:#000;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color:#fff;
        font-size:26px;
        position: fixed;
    }

</style>
